export default __webpack_public_path__ + "static/media/bg_effect.472894ba.png";